import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import {
  PaymentSystemListItem,
  PaymentSystemListRequestPayload,
} from '@/models/dictionary/payment-system-list.model';

export default class GetPaymentSystemListRequest extends ApiResourceMethod<PaymentSystemListItem[]> {
  public perform(filterList: PaymentSystemListRequestPayload): Promise<PaymentSystemListItem[]> {
    return this.performer.requestWithMapper(
      { params: filterList },
      ({ data }: BaseResponse<PaymentSystemListItem[]>): PaymentSystemListItem[] => data,
    );
  }
}
